import { render, staticRenderFns } from "./ForgotPasswordSubmit.vue?vue&type=template&id=c53a983e&"
import script from "./ForgotPasswordSubmit.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordSubmit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports